import { Button, FlexBox, Text } from '@dixa/lib-shared-habla';

type ReviewStatusProps = {
  onClick: () => void;
};

export const ReviewStatus = ({ onClick }: ReviewStatusProps): JSX.Element => {
  return (
    <FlexBox
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      height="100%"
    >
      <Text.Paragraph subdued variant="1">
        The review has been updated.
      </Text.Paragraph>
      <Text.Paragraph subdued withMarginBottom variant="1">
        You can still edit your original reply
      </Text.Paragraph>
      <Button onClick={onClick}>Edit reply</Button>
    </FlexBox>
  );
};
